/**
 * Seeds draftAnswers from API preference questionnaire payload.
 *
 * Belongs here: initial answer map.
 * Does not belong here: React state.
 */
import type {
  PreferenceQuestionnaireDataResponse,
  PreferencesAnswersMap
} from '../preferences/setup/types'
import { isSegmentIntroQuestion } from './preferencesMappers'

/** Builds initial answers map from preferences questionnaire payload (e.g. when API returns saved answers). */
export function buildInitialAnswersFromPreferencesPayload(
  data: PreferenceQuestionnaireDataResponse | undefined
): PreferencesAnswersMap {
  const map: PreferencesAnswersMap = {}
  const groups = data?.questionGroups ?? []
  for (const group of groups) {
    for (const question of group?.questions ?? []) {
      const questionId = question?.id
      const input = question?.input
      if (!questionId || !input) continue
      const type = input?.type ?? 'SINGLE_SELECT'
      // SEGMENT_INTRO has no answer to seed
      if (isSegmentIntroQuestion(question)) continue
      if (type === 'AMOUNT') {
        const num = input?.inputDataNumber
        if (typeof num === 'number' && !Number.isNaN(num)) map[questionId] = num
        continue
      }
      const selectedIds = input?.selectedOptionIds
      if (!Array.isArray(selectedIds) || selectedIds.length === 0) continue
      if (type === 'MULTI_SELECT_GROUPS') {
        map[questionId] = [...selectedIds]
        continue
      }
      map[questionId] = selectedIds.length === 1 ? selectedIds[0] : [...selectedIds]
    }
  }
  return map
}
